import * as moment from 'moment';
export const getDateWithTimezone = (date) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.replaceAll('_', ' ');
    return `${moment.utc(date).format('lll')} ${timezone}`;
};
